export default "__VITE_ASSET__Capt$2cn__"